import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { LoadingService } from '@core/loading.service';
import { ModalController } from '@ionic/angular';
import { map, Subject, takeUntil } from 'rxjs';
import { RegProfileDialogComponentComponent } from 'src/app/components/reg-profile-dialog-component/reg-profile-dialog-component.component';
import { StorePaymentComponent } from 'src/app/pages/store/store-payment/store-payment.component';
import { SyndicateTicketsComponent } from 'src/app/pages/syndicate/syndicate-tickets/syndicate-tickets.component';
import { PaymentService } from '../payment.service';
import { VoucherService } from '../vouchers.service';

@Injectable({
  providedIn: 'root'
})
export class SyndicatePaymentService {


  private unsubscribe$ = new Subject<void>();
  constructor(
    private modalCtrl: ModalController,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private loadingService: LoadingService,
    private voucherService: VoucherService,
    private matDialog: MatDialog,
    private paymentService: PaymentService
  ) { }

  async showPaymentOptions(syndicate: Data) {
    const paymentOptions = await this.modalCtrl.create({
      component: StorePaymentComponent,
      componentProps: {
        data: this.getCartAndPaymentDetails(syndicate),
      },
    });

    return paymentOptions.present();
  }

  // This function used to get cart and payment details of the syndicate
  private getCartAndPaymentDetails(syndicate: Data) {
    if (!syndicate || !syndicate?.products) return;
    try {
      return {
        prize: syndicate?.price,
        checkout: true,
        draw: "",
        game: syndicate?.ps_name,
        lines:
          syndicate.products?.length > 1
            ? syndicate?.products?.map((l) => l?.total_lines)?.reduce((a, b) => a + b)
            : syndicate?.products?.reduce((prev, next) => prev?.total_lines + next?.total_lines)?.total_lines,
        offer_id: syndicate?.sId,
        real_name: syndicate?.ps_name,
        isCreatingPS: true,
        status: status,
        psId: syndicate?.sId,
        page: "syndicate",
      };
    } catch (e) {
      return e;
    }
  }

  storePaymentPage(data: Data): void {
    const url = this.router
      .createUrlTree([], { relativeTo: this.route, queryParams: { TP1: data?.TP1 } })
      .toString();
    this.location.go(url);
    this.modalCtrl
      .create({
        component: StorePaymentComponent,
        cssClass: "modal-fullScreen",
        componentProps: {
          data: data,
        },
      })
      .then((paymentModal) => {
        this.loadingService.dismiss();
        paymentModal.present();
        paymentModal.onDidDismiss().then((res: Data) => {
          if (res?.data && res?.data?.p_type == "10") {
            const sqlAPICallResponse = res?.data?.syndicateId;
            if (!sqlAPICallResponse) {
              this.voucherService.setSyndicatePending();
              this.matDialog.open(RegProfileDialogComponentComponent, {
                panelClass: "ongoingWarning-size",
                backdropClass: "ongoingWarning-back-drop-color",
                disableClose: true,
              });
              return;
            }
          }
          if (res?.data && res?.data?.syndicateId) {
            this.paymentService
              .getSyndicateInfoWithProducts(res?.data?.syndicateId)
              .pipe(
                takeUntil(this.unsubscribe$),
                map((detail: Data) => {
                  if (!detail?.[0]?.data()) return;
                  const syndicateInfo = detail?.[0].data();
                  syndicateInfo.product = [];
                  const productDocs = detail?.[1].docs;
                  for (let index = 0; index < productDocs?.length; index++) {
                    syndicateInfo.product.push(productDocs?.[index]?.data());
                  }
                  if (!syndicateInfo) return;
                  syndicateInfo["cardType"] = "Managed";
                  return syndicateInfo;
                })
              )
              ?.subscribe(
                (syndicateInfo) => {
                  this.showTicket(syndicateInfo, paymentModal);
                },
                (err) => {
                  return err;
                }
              );
          }
        });
      })
      .catch((err) => {
        return err;
      });
  }

  async showTicket(syndicateInfo: Data, paymentModal: HTMLIonModalElement) {
    const syndicateTickets = await this.modalCtrl.create({
      component: SyndicateTicketsComponent,
      componentProps: { syndicate: syndicateInfo },
      cssClass: "modal-fullScreen",
    });

    syndicateTickets
      .onDidDismiss()
      .then(() => {
        paymentModal.dismiss();
      })
      .catch((err) => {
        return err;
      });
    return await syndicateTickets.present();
  }
}
